import React, { Component } from 'react';
import 'assets/css/geral.css';
import { Tooltip } from '@material-ui/core';
import Parser from 'html-react-parser';

class BotaoCheckList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Tooltip
          title={
            <>
              <h5>{this.props.parecer.areaTecnica.descricao}</h5>
              <p style={{ wordWrap: 'break-word' }}>
                {Parser(String(this.props.parecer.justificativa))}
              </p>
            </>
          }
        >
          <span
            className="bolinha-checklist"
            style={{
              backgroundColor: this.props.parecer.parecerTecnico
                ? this.props.parecer.parecerTecnico.cor
                : 'lightgray',
            }}
          />
        </Tooltip>
      </div>
    );
  }
}

export default BotaoCheckList;
